
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const rp313 = {
    label: "Receipt Payments Balance Sheet",
    pageLabel: "Receipt Payments Balance Sheet",
    starting: true,
    url: "rp313",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Region",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "region",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Parent Branch",
            label: "Parent Branch",
            name: "parentbranch",
            description: "Enter Parent Branch"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Parent Branch ",
            name: "parentbranch",
            description: "Enter Parent Branch Code"
          },
          {
            inputType: "showdata",
            data: "Main Branch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "with Branch",
            name: "withbranch",
            description: ""
          },
         
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "From-To Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "Fromdate",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "Todate",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          }, 
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Transaction Type",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "All",
                value: "All"
              },
              {
                label: "Cash",
                value: "Cash"
              },
              {
                label: "Transfer",
                value: "Transfer"
              },
              {
                label: "Clearing",
                value: "Clearing"
              }
             ],
            placeHolder: "Transaction Type",
            name: "TransactionType",
            description: "Enter Transaction Type"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Receipt/Payment",
            name: "",
            description: "Enter Transaction Type" 
          },        
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Receipts",
                value: "Receipts"
              },
              {
                label: "Payments",
                value: "Payments"
              },
              {
                label: "Receipts And Payments",
                value: "Receipts And Payments"
              },
              {
                label: "Opening balance Receipts And Payments",
                value: "Opening balance Receipts And Payments"
              },{
                label: "Receipts Payments and Closing balance",
                value: "Receipts Payments and Closing balance"
              },{
                label: "Opening Balance Receipts Payments and Closing balance",
                value: "Opening Balance Receipts Payments and Closing balance"
              },
             ],
            placeHolder: "Receipt/Payment",
            name: "Receipt_Payment",
            description: "Enter Receipt/Payment"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter " 
          },
         
               
         
    ]
}

export default rp313;